import script from "./ManutAlertasTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutAlertasTabPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutAlertasTabPage.vue?vue&type=style&index=0&id=0378153c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0378153c"]])

export default __exports__